<template>
  <div class="d-flex align-start">
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="mt-1">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- Đóng kỳ / Mở kỳ (previously Đóng băng) -->
        <v-list-item @click="toggleFreeze">
          <v-list-item-icon class="mr-3">
            <v-icon :color="isFrozen ? 'warning' : 'error'">mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="isFrozen ? 'warning--text' : 'error--text'">
              {{ freezeButtonText }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="frozenInfoLocal" style="font-size: 11px;">
              {{ frozenInfoLocal }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({ period: 'tuitionFeePeriod/detailPeriod' }),
    frozenInfoLocal() {
      if (!this.isFrozen) return ''
      const frozenBy = get(this.period, 'frozenBy')
      const frozenAt = get(this.period, 'frozenAt')
      if (frozenBy && frozenAt) {
        return `Cập nhật lần cuối lúc ${moment(frozenAt).format('HH:mm DD/MM/YYYY')} bởi ${get(frozenBy, 'name')}`
      }
      return ''
    },
    isFrozen() {
      return get(this.period, 'isFrozen', false)
    },
    freezeButtonText() {
      return this.isFrozen ? 'Mở kỳ' : 'Đóng kỳ'
    },
  },
  methods: {
    ...mapActions({ 
      freezePeriod: 'tuitionFeePeriod/freezePeriod',
      unfreezePeriod: 'tuitionFeePeriod/unfreezePeriod',
      fetchPeriod: 'tuitionFeePeriod/fetchPeriod'
    }),
    toggleFreeze() {
      const currentState = this.isFrozen
      const periodId = this.period.id
      let convertFullDate = this.$options.filters.convertFullDate(this.period.title)
      let title = `Xác nhận đóng kỳ học phí ${convertFullDate}`,
        text = `Thông tin khoản phí của từng hoá đơn sẽ được lưu cứng lại trong hoá đơn. Và bạn sẽ không thể tổng kết lại sau khi thực hiện thao tác này.`,
        successMessage = 'Đóng kỳ học phí thành công'
      if (currentState) {
        title = `Xác nhận mở kỳ học phí ${convertFullDate}`
        text = `Bạn sẽ có thể tổng kết lại kỳ đóng này sau khi "Mở kỳ"`
        successMessage = 'Mở kỳ học phí thành công'
      }
      this.$dialog.confirm({
        type: 'delete',
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            if (currentState) {
              await this.unfreezePeriod(periodId)
            } else {
              await this.freezePeriod(periodId)
            }
            this.$alert.success(successMessage)
            await this.fetchPeriod(periodId)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>
